import { render, staticRenderFns } from "./ModalShop.vue?vue&type=template&id=5aa8263c&scoped=true&"
import script from "./ModalShop.vue?vue&type=script&lang=js&"
export * from "./ModalShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa8263c",
  null
  
)

export default component.exports